export const RESPONSE_STATUS = {
  CREATED: 201,
  OK: 200,
  UNAUTHORIZED: 401,
};

export const REQUEST_STATUS = {
  FETCHING: "FETCHING",
};

export const DEFAULT_ERROR_MESSAGE =
  "Ups! something went wrong. If the problem persists, please contact us and we will help you.";
